export default function Footer() {
  const group = [
    {
      title: '内容板块',
      links: [
        { label: '精选合集', href: '#collections' },
        { label: '瓜料热榜', href: '#hot' },
        { label: '内容大全', href: '#feed' },
        { label: '素材库', href: '#materials' },
      ],
    },
    {
      title: '快速跳转',
      links: [
        { label: '话题墙', href: '#topics' },
        { label: '使用指引', href: '#guide' },
        { label: '常见问答', href: '#faq' },
        { label: '返回顶部', href: '#top' },
      ],
    },
  ];

  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-background-50/90 font-heading text-xl text-primary-700">
                91
              </span>
              <span className="font-heading text-2xl text-background-50">免费</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/75">
              91免费精选合集把热门瓜料、内容大全与常用素材整理成可一次浏览收藏的集合页，
              按标签与热度分区呈现，降低筛选成本。
            </p>
          </div>

          {group.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/75 transition-colors hover:text-secondary-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/60">© 2026 91免费 · 本站为内容整理导航单页，仅供浏览收藏，内容版权归原作者所有。</p>
          <p className="flex items-center gap-1.5 text-xs text-background-100/60">
            <i className="ri-shield-check-line text-secondary-300" /> 静态展示 · 无需登录 · 仅作信息整理
          </p>
        </div>
      </div>
    </footer>
  );
}